export enum SavedFilterStatus {
  OPEN = "OPEN",
  CLOSED = "CLOSE",
  SENTENCE = "SENTENCE",
  NEXT_DUE_DATE = "NEXTDUEDATE",
  COURT = "COURT",
}

export enum ClaimOwnerShipForFilter {
  MY = "MY",
  ALL = "ALL",
}

export enum FollowupUniqueNames {
  COMMON_FOLLOWUP = "common follow-up",
  ADDRESS_UNKNOWN = "adresse ukjent",
}

export const ALL_REASONS_ID = -1
export const ALL_FILTER_ID = -1

export enum FollowupOrderType {
  REASON = "REASON",
  CASE_HANDLER = "CASE_HANDLER",
}
